import {createContext} from "react";
import type {DefaultColors} from "tailwindcss/types/generated/colors";

import type {colors} from "../../../colors";

type Colors = typeof colors & DefaultColors;

export interface FrontendContext {
    baseUrl: string;
    colors?: Colors;
}

export const FrontendContext = createContext<FrontendContext>({
    baseUrl: "/"
});
